import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  notification,
  Radio,
} from "antd";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import { create } from "../../../../../controllers/store/actions/products/create-product-action";
import { useState } from "react";
import SelectGroup from "../../Elements/Select-Group";
import SelectUniversity from "../../Elements/Select-University";
import { Capacity } from "../../../..";
import SelectSearchers from "../../Elements/Select-Searcher";

interface Props {
  loading?: boolean;
  visible: boolean;
  onCreated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const NewProductModal = (Props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const createdProduct = useSelector((state: any) => state.createdProduct);
  const CapacitiesTypeState = useSelector(
    (state: any) => state.capacitiesTypes
  );

  return (
    <Modal
      open={Props.visible}
      width={600}
      title={"Producto"}
      okText={"Agregar"}
      cancelText="Cancelar"
      footer={null}
      onCancel={Props.onCancel}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (values: any) => {
            form.validateFields().then(async (values: any) => {
              await dispatch(
                create({
                  capacity_type: CapacitiesTypeState.list.find(
                    (c: any) => c.collection_name === Capacity.Products
                  )?.id,
                  nme_producto_pd: values.name,
                  groups: [{ groups_id: values.group?.value }],
                  external_code: values.external_code,
                  persona: "",
                  searchers: values.searchers.map((s: any) => ({
                    searchers_id: s.value,
                  })),
                  universities: [{ universities_id: values.university?.value }],
                  id_producto_pd: values.external_code,
                  fcreacion_pd: new Date().toISOString(),
                  nme_tipologia_pd: values.type,
                  contact_name: values.contact_name,
                  contact_email: values.contact_email,
                })
              );

              Props.onCreated();
            });
          }}
          name="newProduct"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col xs={24} sm={12} md={8} lg={18}>
              <Form.Item
                label="Nombre del producto"
                name="name"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                label="Código"
                name="external_code"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Tipologia"
                name="type"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Nombre de contacto"
                name="contact_name"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Email de contacto"
                name="contact_email"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Institución"
                name="universities"
                rules={[{ type: "array" }]}
              >
                <SelectUniversity
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("universities", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Grupo de investigación"
                name="groups"
                rules={[{ type: "array" }]}
              >
                <SelectGroup
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  mode={"multiple"}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("groups", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Investigadores"
                name="searchers"
                rules={[{ type: "array" }]}
              >
                <SelectSearchers
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  mode={"multiple"}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("searchers", selected);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item wrapperCol={{ span: 24 }}>
            <Button
              loading={createdProduct?.isLoading}
              type="primary"
              size={"large"}
              block
              htmlType="submit"
            >
              Agregar producto
            </Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};
export default NewProductModal;
